import { render, staticRenderFns } from "./ResultPositive.vue?vue&type=template&id=597d79fe&scoped=true&"
import script from "./ResultPositive.vue?vue&type=script&lang=js&"
export * from "./ResultPositive.vue?vue&type=script&lang=js&"
import style0 from "./ResultPositive.vue?vue&type=style&index=0&id=597d79fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d79fe",
  null
  
)

export default component.exports